// Externe Bibliotheken
import React from 'react';

// Styles
import './claimStepProgressBar.scss';

export default function stepProgressBar(props) {
    const steps = props.steps;
    const items = steps.map((step, index) => {
        return (
            <div
                className={
                    'step-item ' +
                    (props.currentStep === step.index ? 'active' : props.currentStep > step.index ? 'completed' : '')
                }
                key={step.index}
                onClick={() => {
                    if (props.currentStep > step.index) {
                        props.setCurrentStep(step.index);
                    }
                }}>
                <div className="step-counter">{props.currentStep <= step.index ? step.index + 1 : ''}</div>
                <div className="step-name">{step.label}</div>
            </div>
        );
    });

    return <div className="stepProgressBar">{items}</div>;
}
